module.exports = __webpack_public_path__ + "img/instagram.9012c394.png";